const PrivilegeRoleEnum = {
  ACCOUNTANT: 5,
  RECEPTION: 6
}
export default PrivilegeRoleEnum


// WEBPACK FOOTER //
// ./src/enum/PrivilegeRoleEnum.js